import { useContext } from 'react'
import { Alert, useMediaQuery, useTheme, Stack, Typography } from '@mui/material'
import { CreateCampaignContext } from '~/contexts/CreateCampaignContext'
import { CampaignCategory } from '~/generated/graphql'
import { staticPath } from '~/lib/$path'
import { CommonStepContent } from './CommonStepContent'
import { LinkToInfo } from '~/components/common/LinkToInfo'
import { EXTERNAL_LINKS } from '~/lib/externalLinks'
import { CreditCardRegistrationAlert } from '~/components/common/CreditCardRegistrationAlert'

export const ExpenseCampaignStep = () => {
  const { campaign, isExpenseCampaignAllowed } = useContext(CreateCampaignContext)
  const isService = campaign.category === CampaignCategory.Service
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const imageSrc = isService
    ? isMobile
      ? staticPath.expense_info_steps.service_expense_campaign_sp_png
      : staticPath.expense_info_steps.service_expense_campaign_pc_png
    : isMobile
      ? staticPath.expense_info_steps.product_expense_campaign_sp_png
      : staticPath.expense_info_steps.product_expense_campaign_pc_png

  const messages = isService
    ? [
        '立替型は、インフルエンサーが一般の顧客と同様にサービスを利用し、当日は自身で会計を行ったうえで、PR投稿完了後に店舗側がその費用を精算する形式です。',
        'インフルエンサーからは、PR投稿完了の報告とあわせて立替精算の申請が提出され、それを店舗が確認・承認することで完了となります。広告主様のご負担額は、立替申請額に還元率を適用した金額となります。',
        '事前にインフルエンサーとの来店調整が不要なため、スムーズにオファーを進めることが可能です。また、予約が必要な場合でも通常のお客様と同様に予約が入るため、特別な対応は必要ありません。',
        '※宿泊施設等の「トラベル」ジャンルに該当する商材は、「インフルエンサー立替型」をご利用いただけません。',
      ]
    : [
        '立替型は、購入時にインフルエンサーが費用を立替え、PR投稿の報告と合わせて立替代金の精算申請を行います。事業者様にて内容を承認いただき、代金を精算する仕組みです。広告主様のご負担額は、立替申請額に還元率を適用した金額となります。',
        'インフルエンサーへの発送連絡等が不要となり、スムーズにオファーを進めることが可能です。 また、注文は一般のお客様と同じようにサイト経由で入るため、特別な対応は必要ありません。',
      ]

  return (
    <CommonStepContent
      imageSrc={imageSrc}
      alt={isService ? 'noChargeCampaignStepServiceImage' : 'noChargeCampaignStepProductImage'}
    >
      <Stack gap={1} mb={2}>
        <Alert severity="info" icon={isMobile ? false : undefined}>
          <Stack gap={0.5}>
            <Stack gap={0.5}>
              {messages.map((line, index) => (
                <Typography key={index} variant="body2">
                  {line}
                  <br />
                </Typography>
              ))}
            </Stack>

            <LinkToInfo href={EXTERNAL_LINKS.EXPENSE_FAQ} textAfter="をご確認ください。" />
          </Stack>
        </Alert>
        {!isExpenseCampaignAllowed && <CreditCardRegistrationAlert />}
      </Stack>
    </CommonStepContent>
  )
}
